import dayjs from "dayjs";

// Mirrors the CHECK constraints in database/insighteye-lost-found-integration.sql.
export const EVENT_STATUS_OPTIONS = [
  { value: "open", label: "Open" },
  { value: "acknowledged", label: "Acknowledged" },
  { value: "resolved", label: "Resolved" },
  { value: "false_positive", label: "False Positive" },
];
export const FOUND_STATUSES = ["unclaimed", "claimed", "discarded"];
export const LOST_STATUSES = ["open", "matched", "resolved", "closed"];

export const FOUND_STATUS_COLOR = { unclaimed: "warning", claimed: "success", discarded: "default" };
export const LOST_STATUS_COLOR = { open: "warning", matched: "info", resolved: "success", closed: "default" };

/**
 * Item types a report can name. The detector (COCO) produces bag, umbrella and
 * mobile_phone; the others stay reportable and still match on colour, time and photo.
 */
export const OBJECT_CLASSES = ["bag", "umbrella", "mobile_phone", "wallet", "hand_watch", "key", "glasses"];

/** The colour names the backend assigns to crops (app/services/lost_found/color.py). */
export const ITEM_COLORS = [
  "black", "gray", "white", "brown", "beige", "red", "orange",
  "yellow", "green", "cyan", "blue", "purple", "pink",
];

/** lost_found_match_min_score on the backend: suggestions below it are hidden. */
export const DEFAULT_MIN_MATCH_SCORE = 0.3;

/** lost_found_max_upload_bytes on the backend, checked here before uploading. */
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
export const ACCEPTED_PHOTO_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/bmp"];

export const titleCase = (value) =>
  value
    ? String(value)
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (c) => c.toUpperCase())
    : "—";

export const formatDateTime = (value) => (value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "—");

export const formatScore = (value, digits = 0) =>
  value === null || value === undefined || Number.isNaN(Number(value))
    ? "—"
    : `${(Number(value) * 100).toFixed(digits)}%`;

/** Seconds as a human span: 45s, 3m 20s, 2h 05m. */
export function formatDuration(seconds) {
  if (seconds === null || seconds === undefined || Number.isNaN(seconds)) return "—";
  const total = Math.max(0, Math.round(seconds));
  if (total < 60) return `${total}s`;
  const minutes = Math.floor(total / 60);
  const secs = total % 60;
  if (minutes < 60) return `${minutes}m ${String(secs).padStart(2, "0")}s`;
  const hours = Math.floor(minutes / 60);
  return `${hours}h ${String(minutes % 60).padStart(2, "0")}m`;
}

export const formatNumber = (value, digits = 0) =>
  value === null || value === undefined || Number.isNaN(Number(value))
    ? "—"
    : Number(value).toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });

/** Error text from an axios error (FastAPI puts it in detail, as a string or a list). */
export const errorText = (err, fallback = "Something went wrong.") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) return detail.map((d) => d.msg || String(d)).join("; ");
  return err?.response?.data?.message || err?.message || fallback;
};
